module.exports = __webpack_public_path__ + "static/media/Sprinta2017.f5edaa66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/v2/atoms/FontIcon/fonts/Sprinta2017.svg
// module id = 965
// module chunks = 0 1 2 3